/* "Email me this result" for the AV tools (i3). Rendered by snippets/tool-email.liquid.
   Builds a plain-text summary from what is on screen - the tool's labelled inputs, the pressed
   option buttons and the result panel - plus a link back to these exact settings when the tool
   registers with CHTToolShare. Posts it to the account worker on op=atmosplan (the route the
   Atmos planner and room-mode calculator already use); the worker emails the shopper, posts a
   Slack leads card and fires a Klaviyo "Tool result" event. No per-tool code. */
if (!window.__cht_toolmail) {
  window.__cht_toolmail = true;
  (function () {
    function clean(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); }
    function track(key, action, data) {
      try { var d = Object.assign({ event: 'cht_tool', tool: key, action: action }, data || {}); (window.dataLayer = window.dataLayer || []).push(d); window.dispatchEvent(new CustomEvent('cht:tool', { detail: d })); } catch (e) {}
    }
    function visible(el) { return !!(el && el.offsetParent !== null && !el.closest('[hidden]')); }

    /* Labelled inputs and selects inside the tool root, in DOM order. Skips anything that looks
       like personal data (the trade-in estimator sits inside a contact form) and our own form. */
    function inputsText(root, self) {
      var out = [], seen = {};
      root.querySelectorAll('input, select').forEach(function (el) {
        if (self.contains(el) || !visible(el)) return;
        var t = (el.type || '').toLowerCase();
        if (t === 'hidden' || t === 'email' || t === 'tel' || t === 'password' || t === 'submit' || t === 'button') return;
        var nm = (el.name || el.id || '').toLowerCase();
        if (/name|email|phone|postcode|address|suburb/.test(nm)) return;
        var lab = '';
        if (el.id) { var l = root.querySelector('label[for="' + el.id.replace(/"/g, '') + '"]'); if (l) lab = clean(l.textContent); }
        if (!lab) { var w = el.closest('label'); if (w) lab = clean(w.textContent.replace(clean(el.value), '')); }
        if (!lab && el.getAttribute('aria-label')) lab = clean(el.getAttribute('aria-label'));
        if (!lab) return;
        var val = '';
        if (t === 'checkbox') { if (!el.checked) return; val = 'yes'; }
        else if (t === 'radio') { if (!el.checked) return; val = clean(el.value); }
        else if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; val = o ? clean(o.textContent) : ''; }
        else val = clean(el.value);
        if (!val) return;
        var unit = ''; var row = el.closest('.calc-inputrow, .scalc-row, .pjc-row, .ccalc-row, .rmc-row'); if (row) { var u = row.querySelector('.calc-unit, [class*="unit"]'); if (u) unit = ' ' + clean(u.textContent); }
        var line = lab.replace(/\s*[:*]$/, '') + ': ' + val + unit;
        if (seen[line]) return; seen[line] = 1;
        out.push(line);
      });
      /* Pressed option buttons (unit toggles, layout pickers, seat tabs). */
      var pressed = [];
      root.querySelectorAll('[aria-pressed="true"], [aria-selected="true"], .is-on').forEach(function (b) {
        if (self.contains(b) || !visible(b)) return;
        var txt = clean(b.textContent).slice(0, 40); if (txt && pressed.indexOf(txt) < 0) pressed.push(txt);
      });
      if (pressed.length) out.push('Options: ' + pressed.slice(0, 12).join(' · '));
      return out.slice(0, 30);
    }

    function resultText(sel) {
      if (!sel) return '';
      var best = '';
      document.querySelectorAll(sel).forEach(function (el) {
        if (!visible(el)) return;
        var lines = [];
        /* Walk block-ish descendants so table rows and cards keep one line each. */
        var blocks = el.querySelectorAll('tr, li, p, h2, h3, h4, dt, dd, [class*="row"], [class*="kv"], [class*="stat"], [class*="verdict"], [class*="card"]');
        if (!blocks.length) lines.push(clean(el.textContent));
        else blocks.forEach(function (b) {
          if (b.closest('[data-toolmail], [data-toolprint], [data-toolshare]')) return; /* our own controls */
          if (b.querySelector('tr, li, [class*="row"], [class*="kv"]')) return; /* container - children carry the text */
          var t = clean(b.textContent); if (t && lines.indexOf(t) < 0) lines.push(t);
        });
        var txt = lines.join('\n');
        if (txt.length > best.length) best = txt;
      });
      return best.slice(0, 3000);
    }

    document.querySelectorAll('[data-toolmail]').forEach(function (box) {
      var key = box.getAttribute('data-tool') || 'tool';
      var title = box.getAttribute('data-title') || 'Tool result';
      var form = box.querySelector('[data-toolmail-form]');
      var msg = box.querySelector('[data-toolmail-msg]');
      var rootSel = box.getAttribute('data-root');
      var root = (rootSel && document.querySelector(rootSel)) || box.closest('section, .shopify-section') || document.body;
      if (!form) return;
      function say(t, ok) { if (!msg) return; msg.textContent = t; msg.classList.toggle('is-ok', !!ok); msg.classList.toggle('is-err', !ok); }

      function planText() {
        var L = [title, ''];
        var ins = inputsText(root, box);
        if (ins.length) { L.push('Your settings'); ins.forEach(function (s) { L.push('  ' + s); }); L.push(''); }
        var res = resultText(box.getAttribute('data-result'));
        if (res) { L.push('Result'); res.split('\n').forEach(function (s) { L.push('  ' + s); }); L.push(''); }
        var url = null;
        try { if (window.CHTToolShare && CHTToolShare.url) url = CHTToolShare.url(key); } catch (e) {}
        L.push('Open these settings: ' + (url || (location.origin + location.pathname)));
        return L.join('\n');
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var hp = box.querySelector('[data-toolmail-hp]');
        if (hp && hp.value) { say('Sorry, that didn’t work. Call us on 1800 100 998 and we’ll send it over.', false); return; }
        var em = clean(form.email.value), nm = clean(form.name.value).slice(0, 80);
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { form.email.focus(); say('Please enter a valid email address.', false); return; }
        var plan = planText();
        if (plan.length < 40 || !resultText(box.getAttribute('data-result'))) { say('Enter your numbers above first, then send the result.', false); return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn.getAttribute('data-busy') === '1') return;
        btn.setAttribute('data-busy', '1'); btn.disabled = true; var old = btn.textContent; btn.textContent = 'Sending…';
        var consult = !!(box.querySelector('[data-toolmail-consult]') || {}).checked;
        track(key, 'email_result', { consult: consult });
        var proxy = (window.CHT_ACCOUNT && CHT_ACCOUNT.proxy) || '/apps/cht';
        var url = proxy + (proxy.indexOf('?') > -1 ? '&' : '?') + 'op=atmosplan';
        var req = fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ email: em, name: nm, plan: plan, source: key, title: title, consult: consult, hp: hp ? hp.value : '', page: location.href }) })
          .then(function (r) { return r.json().catch(function () { return { ok: false }; }); }).catch(function () { return { ok: false }; });
        var slow = new Promise(function (res) { setTimeout(function () { res({ ok: false, error: 'That took too long to send. Please try again, or use Print / Save as PDF.' }); }, 10000); });
        Promise.race([req, slow]).then(function (d) {
          if (d && d.ok) { say('Sent to ' + em + '.' + (consult ? ' A specialist will be in touch within one business day.' : ''), true); box.classList.add('is-sent'); }
          else say((d && d.error) || 'We couldn’t send that just now. Use Print / Save as PDF to keep your result, or try again shortly.', false);
          btn.removeAttribute('data-busy'); btn.disabled = false; btn.textContent = old;
        });
      });
    });
  })();
}
